<template>
  <div class="customTable caption">
    <table style="width:100%">
      <tr v-for="item in Object.keys(data)" :key="item.id">
        <td class="pa-2 table-header text-center font-weight-bold" style="width: 30% !important">
          {{ data[item] }}
        </td>
        <td class="pa-2" style="width: 70% !important">
          <!-- Tecnicos -->
          <span v-if="item === 'technicians'">
            {{ preview.technicians && preview.technicians.join(', ') }}
          </span>
          <!-- Fecha Inspección -->
          <span v-else-if="item === 'work_first_date'">
            {{ formatDate(preview.work_first_date) }}
          </span>
          <!-- Numero Serie -->
          <span v-else-if="item === 'blades'">
            <div v-for="blade in Object.keys(preview.blades)" :key="blade.id">
              PALA {{ blade }} - {{ preview.wind_blade_serial_numbers[blade] }}
            </div>
          </span>
          <!-- Everything else -->
          <span v-else>
            {{ preview[item] }}
          </span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import Util from "@/util/index";

export default {
  props: {
    preview: { type: Object, default: () => {} }
  },
  data: () => ({
    data: {
      work_order_code: 'Número OT',
      contractor: 'Subcontrata',
      technicians: 'Técnicos',
      wind_turbine: 'Número AG',
      wind_turbine_type: 'Modelo AG',
      wind_farm: 'Parque',
      work_first_date: 'Fecha Inspección',
      wind_turbine_blade_type: 'Modelo Pala',
      blades: 'Número Serie',
    }
  }),
  methods: {
    formatDate(date) {
      return Util.formatDate(date)
    },
  }

}
</script>
